module.exports = __webpack_public_path__ + "media/images/lp_present_engeneer_kind-c6ed496749ea96b3296078ea8eaec1d0.webp";